import { PropsWithChildren } from 'react';
import styled from '@emotion/styled';

const Wrapper = styled.div`
    display: inline-flex;
    width: 100%;
`;

const Input = styled.input`
    display: none;

    &:checked + label::before {
        background-color: var(--main-color-blue);
        border: none;
        content: '✔';
        color: white;
        text-align: center;
        line-height: 24px;
    }

    &:disabled + label {
        opacity: 0.5;
        cursor: not-allowed;
    }
`;

const Label = styled.label<Partial<Props>>`
    display: inline-flex;
    gap: 8px;
    width: 100%;
    padding: 8px 16px 8px 8px;
    border: ${(props) => (props.disableBorder ? 'none' : '1px solid var(--ash-gray)')};
    border-color: ${(props) => (props.hasError ? 'var(--warn)' : 'var(--ash-gray)')};
    border-radius: 8px;
    background-color: ${(props) => (props.hasError ? 'var(--warn-pale)' : 'var(--white)')};
    font-size: var(--font-medium);
    line-height: 24px;
    text-align: left;
    cursor: pointer;
    &:hover {
        opacity: 0.7;
    }
    &::before {
        content: '';
        display: inline-block;
        width: 24px;
        height: 24px;
        border: 1px solid var(--ash-gray);
        border-radius: 4px;
        background-color: var(--white);
        box-sizing: border-box;
    }
`;

interface Props extends React.InputHTMLAttributes<HTMLInputElement> {
    hasError?: boolean;
    disableBorder?: boolean;
}

/**
 * フォームのチェックボックス
 */
export const FormCheckbox: React.FC<PropsWithChildren<Props>> = ({
    id,
    checked = false,
    readOnly = false,
    disabled = false,
    hasError = false,
    disableBorder = false,
    onChange,
    children,
}) => {
    return (
        <Wrapper>
            <Input
                id={id}
                checked={checked}
                readOnly={readOnly}
                disabled={disabled}
                type="checkbox"
                onChange={onChange}
            />
            <Label htmlFor={id} hasError={hasError} disableBorder={disableBorder}>
                <span>{children}</span>
            </Label>
        </Wrapper>
    );
};
